export default {
  requests: (no) => `attendance/${no}/requests`,
  logs: "attendance/logs ",
  createRequest: "attendance/create-request",
  requestApproval: "attendance/request-approval",
};
